// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__37AwM","rootSuccess":"CompleteLink_rootSuccess__vP_bo","rootFailure":"CompleteLink_rootFailure__3mnCh","isDisabled":"CompleteLink_isDisabled__2fcP_"};